import { useEffect, useState } from 'react';
import { ProductsResponse, SearchService } from '@services';
import { useServiceRef } from './useServiceRef';

export const useProductsByDiscount = (discountId = '', sortBy: string): {
  productsInfo: ProductsResponse | null,
  loadMore: () => Promise<ProductsResponse | null>,
  currentCount: number,
  isLoading: boolean
} => {
  const searchServiceRef = useServiceRef(SearchService);
  const [ productsInfo, setProductsInfo ] = useState<ProductsResponse | null>(null);
  const [ isLoading, setIsLoading ] = useState(false);

  useEffect(() => {
    (async (): Promise<void> => {
      if (discountId) {
        setIsLoading(true);
        const productsResponse = await searchServiceRef.current.getProductsByDiscountId(discountId.toString(), 0, sortBy);
        setProductsInfo(productsResponse);
        setIsLoading(false);
      }
    })();
  }, [ sortBy, discountId ]);

  const loadMore = async (): Promise<ProductsResponse | null> => {
    if (discountId) {
      const newOffset = (productsInfo?.offset ?? 0) + (productsInfo?.count ?? 0);
      const productsResponse = await searchServiceRef.current.getProductsByDiscountId(discountId.toString(), newOffset, sortBy);

      if (productsResponse !== null) {
        setProductsInfo(prevProductsInfo => ({
          ...productsResponse as ProductsResponse,
          results: [ ...(prevProductsInfo?.results ?? []), ...(productsResponse?.results ?? []) ]
        }));
      }

      return productsResponse;
    }

    return null;
  };

  const currentCount = (productsInfo?.count ?? 0) + (productsInfo?.offset ?? 0);

  return { productsInfo, loadMore, currentCount, isLoading };
};
